import {gsap, Power1, Power2, Power3, Power4, Expo, Sine} from "gsap";
import spanWrapText from './spanWrapText'
import setHeroSlider from "./setHeroSlider";

const initAnim = () => {
  const siteName = document.querySelectorAll('#site-header .site-name, .section-hero .hero__title');
  spanWrapText(siteName);
  siteName.forEach((el) => {
    el.style.opacity = 1;
  })
  
  const heroBgLogo = document.querySelectorAll('.is-top .section-hero .bg-logo');
  const heroBgLogoOverlay = document.querySelectorAll('.is-top .section-hero .bg-logo-overlay');
  const heroSwiper = document.querySelectorAll('.is-top .section-hero .swiper');
  const heroTitleChar = document.querySelectorAll('.is-top .section-hero .hero__title .char');
  const heroInner = document.querySelectorAll('.is-top .section-hero .hero-inner');
  const header = document.querySelector('#site-header');
  const mastHead = header.querySelector('.masthead');
  const sns = header.querySelector('.sns-icons');
  const gnNav = header.querySelector('#js-gn-menu');
  const heroBg = document.querySelector('.hero-bg');

  var layoutMode = null;
  var LAYOUTMODE__DESKTOP = 1;
  var LAYOUTMODE__MODILE = 2;
  var BREAK_POINT = "(min-width: 769px)";

  function complete() {
    document.querySelector('body').classList.add('is-animated');
  }

  function matchMedia() {
    if (document.querySelector('body').classList.contains('is-top') && !document.querySelector('body').classList.contains('is-animated')) {
      if (window.matchMedia(BREAK_POINT).matches) {
        if (layoutMode == LAYOUTMODE__DESKTOP) return;
        layoutMode = LAYOUTMODE__DESKTOP;

        gsap
          .timeline()
          .set(heroBgLogo, {
            scale: 1,
          })
          .set(heroSwiper, {
            scale: 1.05,
          })
          .to(heroBgLogo, {
            opacity: 1,
            duration: 0.4,
            ease: Sine.easeInOut,
          }, "=0")
          .to(heroBgLogo, {
            scale: 0.15,
            duration: 0.5,
            ease: Power4.easeOut,
          }, "-=.35")
          .to(heroSwiper, {
            scale: 1,
            duration: 1.3,
            ease: Power2.easeOut,
            onComplete: setHeroSlider
          }, "+=.2")
          .to(heroBg, {
            scaleX: 0,
            duration: .9,
            ease: Expo.easeInOut,
          }, "-=1.1")
          .to(heroSwiper, {
            opacity: 1,
            duration: 1,
            ease: Sine.easeInOut,
          }, "<")
          .to(heroBgLogo, {
            scale: 1,
            duration: .9,
            ease: Power4.easeInOut,
          }, "<")
          .to(heroBgLogo, {
            top: 'calc(100% - 330px)',
            right: 'calc(50% - 35px)',
            transform: 'translate(0, 0)',
            duration: .9,
            ease: Power4.easeInOut,
          }, "<")
          .to(heroBgLogoOverlay, {
            opacity: 0,
            duration: .9,
            ease: Sine.easeInOut,
          }, "<")
          .to(heroTitleChar, {
            opacity: 1,
            duration: .8,
            ease: Sine.easeInOut,
            stagger: {
              each: 0.03,
              ease: Power1.In
            },
          }, "-=.6")
          .to(heroInner, {
            opacity: 1,
            duration: 0.6,
            ease: Sine.easeInOut,
          }, "-=.7")
          .to(mastHead, {
            opacity: 1,
            duration: .7,
            ease: Sine.easeInOut,
          }, "-=1")
          .to(sns, {
            opacity: 1,
            duration: .7,
            ease: Sine.easeInOut,
            onComplete: complete
          }, "<")

      } else {
        if (layoutMode == LAYOUTMODE__MODILE) return;
        layoutMode = LAYOUTMODE__MODILE;

        gsap
          .timeline()
          .set(heroBgLogo, {
            scale: .2,
          })
          .set(heroSwiper, {
            scale: 1.05,
          })
          .to(heroBgLogo, {
            opacity: 1,
            duration: 0.4,
            ease: Sine.easeInOut,
          }, "=0")
          .to(heroBgLogo, {
            scale: 0.15,
            duration: 0.5,
            ease: Power3.easeOut,
          }, "-=.35")
          .to(heroSwiper, {
            opacity: 1,
            duration: 1,
            ease: Sine.easeInOut,
          }, "+=.2")
          .to(heroSwiper, {
            scale: 1,
            duration: 1.3,
            ease: Power2.easeOut,
            onComplete: setHeroSlider
          }, "<")
          .to(heroBg, {
            scaleY: 0,
            duration: .9,
            ease: Expo.easeInOut,
          }, "-=1.1")
          .to(heroBgLogo, {
            scale: 1,
            duration: .9,
            ease: Power4.easeInOut,
          }, "<")
          .to(heroBgLogo, {
            top: 'calc(100% - 205px)',
            right: 'calc(50% - 150px)',
            transform: 'translate(0, 0)',
            duration: .9,
            ease: Power4.easeInOut,
          }, "<")
          .to(heroBgLogoOverlay, {
            opacity: 0,
            duration: .9,
            ease: Sine.easeInOut,
          }, "<")
          .to(heroTitleChar, {
            opacity: 1,
            duration: .8,
            ease: Sine.easeInOut,
            stagger: {
              each: 0.03,
              ease: Power1.In
            },
          }, "-=.6")
          .to(heroInner, {
            opacity: 1,
            duration: 0.6,
            ease: Sine.easeInOut,
          }, "-=.7")
          .to(mastHead, {
            opacity: 1,
            duration: .7,
            ease: Sine.easeInOut,
          }, "-=1")
          .to(gnNav, {
            opacity: 1,
            duration: .7,
            ease: Sine.easeInOut,
            onComplete: complete
          }, "<")
      }
    } else {
      complete();
    }
  }

  function resize() {
    matchMedia();
  }

  resize();

  window.addEventListener('resize', function() {
    if(!header.classList.contains('is-animated')) {
      resize()
    }
  });

};

export default initAnim;
